import React from 'react';
import Email from '@mui/icons-material/Email';
import Call from '@mui/icons-material/Call';
import LockReset from '@mui/icons-material/LockReset';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Help.scss';
import { routesPaths } from 'constants/paths';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const Help = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  return (
    <div className="d-flex help">
      <h4 className="page-title">{t('help_need_support')}</h4>
      <div className="d-flex flex-column help-setup-container gap-3">
        <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
          <a
            className="text-white btn btn-primary mb-2 text-nowrap"
            target="_blank"
            rel="noreferrer"
            href="https://mail.google.com/mail/?view=cm&to=support@getinspectsmart.com&fs=1&su=Support Case-"
          >
            <Email color="inherit" />
            <span className="mx-2 email-text">{`${t(
              'email',
            )} (support@getinspectsmart.com)`}</span>
          </a>
          <a
            className="btn btn-primary mb-2 text-white text-nowrap"
            href="tel:+917567683996"
          >
            <Call color="inherit" />
            <span className="mx-2">{`${t('call')} (+91-756-768-3996)`}</span>
          </a>
          <Link
            className="btn btn-primary mb-2 text-white text-nowrap"
            to={routesPaths.changePassword}
          >
            <LockReset color="inherit" />
            <span className="mx-2">{t('help_reset_password')}</span>
          </Link>
        </div>
        <div className="w-100 text-center flex-grow-1 help-bg" />
      </div>
      <div className="my-1">
        <Button
          variant="outlined"
          startIcon={<ArrowBack />}
          color="primary"
          onClick={handleBack}
        >
          {t('btn_back')}
        </Button>
      </div>
    </div>
  );
};

export default Help;
